import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const NodeSensorsSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className={style.block}>
      <div className={style.blockHead}>
        <div className={style.blockTitle}>{t('Node Sensors')}</div>
      </div>
      <div className={style.blockContainer}>
        <div className={style.information}>
          {t(
            'The following sensors are attached to this node. We provide this information to assist you in locating the node. Please note the EAM number ("Equipment") and Bed number ("Alias").',
          )}
          {t(
            'Please also confirm that the Node Serial Number matches the serial number listed in the header of this Action Item.',
          )}
        </div>
        <table className={style.sensorsTable} cellSpacing="0" cellPadding="0">
          <thead className={style.sensorsTableHead}>
            <tr>
              <th className={style.sensorsTableTh}>{t('Port')}</th>
              <th className={style.sensorsTableTh}>{t('Sensor HEX code')}</th>
              <th className={style.sensorsTableTh}>{t('Equipment')}</th>
              <th className={style.sensorsTableTh}>{t('Location')}</th>
            </tr>
          </thead>
          <tbody className={style.sensorsTableBody}>
            {[...Array(5)].map((_) => (
              <tr key={uuidv4()} className={style.sensorsTableBodyRow}>
                <td className={style.sensorsTableTd}>
                  <SkeletonBlock className={style.skeletonSensorsTableItem} />
                </td>
                <td className={style.sensorsTableTd}>
                  <SkeletonBlock className={style.skeletonSensorsTableItem} />
                </td>
                <td className={style.sensorsTableTd}>
                  <SkeletonBlock className={style.skeletonSensorsTableItem} />
                </td>
                <td className={style.sensorsTableTd}>
                  <SkeletonBlock className={style.skeletonSensorsTableItem} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NodeSensorsSkeleton;
